/**
 * Returns styling configuration for line count badges based on thresholds
 * @param {number} lineCount - The number of lines in the file
 * @returns {Object} Style object with fontSize, color, background, fontWeight, and icon
 */
export function getLineCountStyle(lineCount) {
  if (lineCount < 50) {
    // Small files
    return {
      fontSize: '10px',
      color: '#666',
      background: 'transparent',
      fontWeight: 'normal',
      icon: null,
      padding: '2px 6px',
      borderRadius: '10px',
      fontFamily: 'monospace',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    };
  } else if (lineCount < 200) {
    // Normal files
    return {
      fontSize: '11px',
      color: '#666',
      background: 'transparent',
      fontWeight: 'normal',
      icon: null,
      padding: '2px 6px',
      borderRadius: '10px',
      fontFamily: 'monospace',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    };
  } else if (lineCount < 500) {
    // Large files
    return {
      fontSize: '12px',
      color: '#666',
      background: 'transparent',
      fontWeight: 'normal',
      icon: null,
      padding: '2px 6px',
      borderRadius: '10px',
      fontFamily: 'monospace',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    };
  } else if (lineCount < 1000) {
    // Very large files
    return {
      fontSize: '12px',
      color: '#666',
      background: 'transparent',
      fontWeight: 'bold',
      icon: null,
      padding: '2px 6px',
      borderRadius: '10px',
      fontFamily: 'monospace',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    };
  } else {
    // Massive files
    return {
      fontSize: '13px',
      color: '#666',
      background: 'transparent',
      fontWeight: 'bold',
      icon: null,
      padding: '2px 6px',
      borderRadius: '10px',
      fontFamily: 'monospace',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    };
  }
}

